import {Message} from './types';

export const jsonParser = (m: Message): Message => {
	if (m.parsed) {
		return m;
	} else if (m.source !== 'ASSISTANT' && m.source !== 'METADATA') {
		return m;
	}

	return {
		...m,
		parsed: JSON.parse(m.message),
	};
};

export type ResponseANL = {
	bot_message: string
	user_links: {
		target: string
		description: string
	}[]
	user_answers: {
		option: string
	}[]
}

export const parsedANL = (message: Message, isLast?: boolean): ResponseANL => {
	let parsed = message.parsed as ResponseANL || {
		bot_message: message.message,
		user_links: [],
		user_answers: [],
	};

	if (isLast && !parsed.user_answers.length && !parsed.user_links.length) {
		parsed = {
			...parsed,
			user_answers: [{
				option: 'Please tell me more! 🤔',
			}],
		};
	}

	return parsed;
};
